import { render, staticRenderFns } from "./UpdateUserDataComponent.vue?vue&type=template&id=c5127618&"
import script from "./UpdateUserDataComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateUserDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports